import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const EventRegistration = () => {
  const { eventName } = useParams();
  const [visitor, setVisitor] = useState({ name: '', email: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setVisitor({ ...visitor, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would send registration data to backend
    setSubmitted(true);
  };

  if (submitted) {
    return <div className="p-6">Thank you for registering for {decodeURIComponent(eventName)}!</div>;
  }

  return (
    <div className="p-6 max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4">Register for {decodeURIComponent(eventName)}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label>Name</label>
          <input name="name" value={visitor.name} onChange={handleChange} required className="border p-2 w-full" />
        </div>
        <div>
          <label>Email</label>
          <input name="email" type="email" value={visitor.email} onChange={handleChange} required className="border p-2 w-full" />
        </div>
        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">Register</button>
      </form>
    </div>
  );
};

export default EventRegistration;
